// removed by extract-text-webpack-plugin
module.exports = {"marketing-list-item":"style__marketing-list-item___2VRdm","item-info":"style__item-info___2WhDP","item-controls":"style__item-controls___31CsP","item-type":"style__item-type___WMhki","item-module":"style__item-module___2c-hE","change-item-order":"style__change-item-order___1mH1g"};


//////////////////
// WEBPACK FOOTER
// ./components/MarketingListItem/style.scss
// module id = 1395
// module chunks = 0